import { accountScopedKey } from '../../account/accountRegistry';

// How the Cycle Clock remembers its choices (scope, stage, depth, filters open): account-scoped in this
// browser, never in user settings, so remembering one never writes the settings record (the DWLF-508 class:
// a save over settings that were not read) and sign-out clears it. `parse` turns the stored string, or null
// when there is none, into the value; anything unreadable reads as `parse(null)`. A save that fails (private
// mode) leaves the default for next time.
export const rememberedSetting = (name, { parse, serialize = String }) => ({
  read: () => {
    try {
      return parse(localStorage.getItem(accountScopedKey(name)));
    } catch (e) {
      return parse(null);
    }
  },
  save: (value) => {
    try { localStorage.setItem(accountScopedKey(name), serialize(value)); } catch (e) { /* private mode */ }
  },
});

/** A multi-select's stored form: the ids `order` knows, in its order; none ticked (or unreadable) = []. */
export const chipsCodec = (order) => ({
  parse: (raw) => {
    const v = raw == null ? [] : JSON.parse(raw);
    return Array.isArray(v) ? order.filter((id) => v.includes(id)) : [];
  },
  serialize: (ids) => JSON.stringify(order.filter((id) => ids.includes(id))),
});

export const rememberedChips = (name, order) => rememberedSetting(name, chipsCodec(order));

/** Ticks or unticks one chip of a multi-select, keeping `order`. */
export const toggleChip = (order, ids, id) => order.filter((f) => (f === id ? !ids.includes(f) : ids.includes(f)));

// Whether the Clock's chip rows are open (DWLF-548); collapsed unless the user opened them.
const filtersOpen = rememberedSetting('cycle-clock-filters-open', { parse: (raw) => raw === '1', serialize: (open) => (open ? '1' : '0') });
export const readFiltersOpen = filtersOpen.read;
export const saveFiltersOpen = filtersOpen.save;
